import React, { Component } from 'react'
import Sidebar from '../multi/Sidebar'
import Blog from '../multi/Blog'

class Home extends Component {
  render = () => {

    return (
      <div>

        <div className="heroImg vh-25 flex justify-end vh-50-ns">
          <div className="heroText pathway ma3 pa3 bg-black self-end near-white f4 f3-ns">
            Eureka, MO
          </div>
        </div>
        <div id="maincontent" className="w-100 pa2 bg-moon-gray flex flex-column flex-row-l items-start-l">
          <Sidebar/>
          <Blog/>
        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/pages/Home.js